






































import { Vue, Component, Prop } from "vue-property-decorator";
import { AuthModule } from "@/stores/modules/AuthModule";
import SbbImageComponent from "@/components/SbbImageComponent.vue";
import { mapGetters } from "vuex";

@Component({
  components: { SbbImageComponent },
  computed: {
    ...mapGetters(["isUserLoggedIn"])
  }
})
export default class LoginView extends Vue {
  private isUserLoggedIn!: boolean;
  private userName: string = "";
  private password: string = "";

  private alertText: string = "";

  constructor() {
    super();
  }

  private mounted() {
    if (this.isUserLoggedIn) this.go();
  }

  private go() {
    this.$router.push(
      this.$route.query.returnUrl
        ? { path: this.$route.query.returnUrl as string }
        : { name: "home" }
    );
  }

  private onSubmit(evt: any): void {
    evt.preventDefault();
    AuthModule.Login({ userName: this.userName, password: this.password })
      .then(res => {
        this.go();
      })
      .catch(err => {});
  }
}
